import {useState} from 'react'
import {useSnapshot} from 'valtio'
import {store, t} from '@/form.js'
import {getMerchant} from '@/config/merchant.js'
import {getOrderDate} from '@/config/orderDate.js'
import illustration from './order-illustration.png'
import styles from './BrandPanel.module.css'

export function BrandPanel() {
  const appState = useSnapshot(store.appSlice.state)
  const formState = useSnapshot(store.cardFormSlice.state)

  // Remembers the URL that failed rather than a flag, so a later merchant with
  // a working logo is not tarred with the same brush.
  const [brokenLogo, setBrokenLogo] = useState('')

  const {params} = appState
  const merchant = getMerchant(params, formState.init.data, formState.paymentWidgetData)
  const logo = merchant.logo && merchant.logo !== brokenLogo ? merchant.logo : ''
  const orderDate = getOrderDate(params)

  /*
   * "Ваш лого" in the mock-ups is a stand-in for the merchant's own logo, not
   * copy: a merchant without one gets no logo block at all. Nothing is drawn
   * in its place, so there is no placeholder to flash while /form/init is
   * still in flight, and a logo URL that fails to load collapses to the
   * merchant name instead of leaving a hole.
   */
  return (
    <aside className={styles.panel}>
      {logo && (
        <div className={styles.logo}>
          <img
            className={styles.logoImage}
            src={logo}
            alt={merchant.name || ''}
            onError={() => setBrokenLogo(logo)}
          />
        </div>
      )}

      {!logo && merchant.name && (
        <div className={styles.logo}>
          <p className={styles.logoText}>{merchant.name}</p>
        </div>
      )}

      <h1 className={styles.title}>
        {t('Brand:Title')}
      </h1>

      <p className={`caption ${styles.descriptionLabel}`}>
        {t('Brand:DescriptionLabel')}
      </p>

      <p className={styles.description}>
        {merchant.name
          ? t('Brand:DescriptionNamed', {order: params.order, merchant: merchant.name})
          : t('Brand:Description', {order: params.order})}
      </p>

      <div className={styles.meta}>
        <p className={`caption ${styles.metaLabel}`}>
          {t('Brand:DateLabel')}
        </p>
        <p className={styles.metaValue}>{orderDate}</p>
      </div>

      {/* Desktop only: on a phone the panel is a header block with no room to
          fill, and the artwork would just push the form off the screen. */}
      <img className={styles.illustration} src={illustration} alt="" aria-hidden="true"/>
    </aside>
  )
}
